import React from "react";
import { TextInput, Button, Paper, Container, Select, Title, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { MSIcon } from "components/MSIcon";
import api from "../services/ApiService";
import { useTrans } from "core";
import { useNavigate } from "react-router-dom";
import { Api_Features } from "../../../constants/SubApi.js";

export default function AddFeaturesScreen() {
	const { t } = useTrans();
	const navigate = useNavigate();

	const [nameAr, setNameAr] = React.useState("");
	const [nameEn, setNameEn] = React.useState("");
	const [selectedType, setSelectedType] = React.useState(null);
	const [saving, setSaving] = React.useState(false);

	const options = [
		{ value: "1", label: t("features.check") },
		{ value: "2", label: t("features.input") },
	];

	const validate = () => {
		if (!nameAr || !nameEn || !selectedType) {
			notifications.show({
				title: t("messages.error"),
				message: t("features.fillAllFields"),
				color: "red",
				icon: <MSIcon name="alert-circle" />,
			});
			return false;
		}
		return true;
	};

	const saveFeature = async () => {
		if (!validate()) return;

		setSaving(true);

		try {
			await api.post(`/${Api_Features}`, {
				name_ar: nameAr,
				name_en: nameEn,
				type: Number(selectedType),
			});

			notifications.show({
				title: t("messages.success"),
				message: t("features.successFeauters"),
				color: "green",
				icon: <MSIcon name="check" />,
			});

			setNameAr("");
			setNameEn("");
			setSelectedType(null);
		} catch (err) {
			const msgKey = err?.data?.message || "features.faliedFeauters";

			notifications.show({
				title: t("messages.error"),
				message: t(msgKey),
				color: "red",
				icon: <MSIcon name="alert-circle" />,
			});
		} finally {
			setSaving(false);
		}
	};

	return (
		<Container size={500} my={20}>
			<Title mb={20}>{t("features.addFeauters")}</Title>

			<Paper p={25} shadow="md" withBorder>
				<Stack spacing={20}>
					<TextInput label={t("features.arabicName")} value={nameAr} onChange={(e) => setNameAr(e.target.value)} />

					<TextInput label={t("features.englishName")} value={nameEn} onChange={(e) => setNameEn(e.target.value)} />

					<Select
						label={t("features.type")}
						data={options}
						value={selectedType}
						onChange={setSelectedType}
						placeholder={t("features.type")}
						searchable
						clearable
					/>

					<Button fullWidth loading={saving} onClick={saveFeature}>
						{t("features.save")}
					</Button>

					<Button fullWidth variant="light" onClick={() => navigate(-1)}>
						{t("features.cancel")}
					</Button>
				</Stack>
			</Paper>
		</Container>
	);
}
